(function() {
  var SIZE = 96;
  var MARGIN = 20;
  var ENTER_DURATION = 1800;
  var ENTER_STAGGER = 140;
  var HANDOFF_PROGRESS = 0.72;

  var WANDER_FORCE = 0.04;
  var TURN_SPEED = 0.015;
  var HALF = SIZE / 2;
  var REPULSE_GAP = 4;
  var REPULSE_FORCE = 0.8;
  var BOUND_FORCE = 0.15;
  var FRICTION = 0.98;
  var MAX_SPEED = 0.6;

  var SCROLL_START = 0;
  var SCROLL_END = 0.60;
  var SPIRAL_TURNS = 2;
  var FINAL_SCALE = 7 / SIZE;
  var FINAL_RADIUS = 10;
  var COLOR_START = 0.5;

  var COLOR_CREAM = [241, 239, 236];
  var COLOR_BLACK = [24, 24, 24];

  function rand(a, b) { return a + Math.random() * (b - a); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeOut(t) { return 1 - (1 - t) * (1 - t) * (1 - t); }

  function easeOutDeriv(t) {
    var c = 1 - t;
    return 3 * c * c;
  }

  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  var SCROLL_OFFSET = -100;
  var SCROLL_DURATION = 1200;

  function smoothScrollTo(targetY) {
    var startY = window.scrollY;
    var distance = targetY - startY;
    if (Math.abs(distance) < 1) return;
    var startTime = null;
    function step(now) {
      if (!startTime) startTime = now;
      var progress = Math.min((now - startTime) / SCROLL_DURATION, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function scrollToHash(hash) {
    if (!hash || hash.length < 2) return;
    var target = document.getElementById(hash.slice(1));
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;
    smoothScrollTo(Math.max(0, top));
  }

  function lerpColor(from, to, t) {
    var r = Math.round(lerp(from[0], to[0], t));
    var g = Math.round(lerp(from[1], to[1], t));
    var b = Math.round(lerp(from[2], to[2], t));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  function init(container) {
    var box = container.querySelector('.cover-rituals__particles');
    var screen1 = container.querySelector('.cover-rituals__screen--1');
    var els = Array.from(container.querySelectorAll('.cover-rituals__particle'));
    if (!box || !els.length) return;

    var iconEl = container.querySelector('.cover-rituals__icon');
    var captionEl = container.querySelector('.cover-rituals__icon-caption');

    var defaultPaths = [];
    for (var k = 0; k < els.length; k++) {
      var dp = els[k].querySelector('.cover-rituals__particle-path--default');
      if (!dp) dp = els[k].querySelector('.cover-rituals__particle-path');
      defaultPaths[k] = dp;
    }

    var w, h;

    function measure() {
      var ref = screen1 || box;
      var r = ref.getBoundingClientRect();
      w = r.width; h = r.height;
      if (w < 10 || h < 10) {
        r = container.getBoundingClientRect();
        w = r.width || window.innerWidth;
        h = r.height || window.innerHeight;
      }
    }

    measure();
    if (w < 10 || h < 10) {
      requestAnimationFrame(function retry() {
        measure();
        if (w < 10 || h < 10) { requestAnimationFrame(retry); return; }
        go();
      });
      return;
    }

    function go() {
      var n = els.length;
      var raf = null;
      var t0 = null;
      var visible = true;

      var px = [], py = [], vx = [], vy = [];
      var sx = [], sy = [], ex = [], ey = [];
      var heading = [], delay = [], op = [];
      var released = [];

      var floatX = [], floatY = [];
      var scrollProgress = 0;
      var prevScrollProgress = 0;
      var allReleased = false;
      var floatSnapshotTaken = false;
      var wasFlying = false;

      for (var i = 0; i < n; i++) {
        ex[i] = rand(MARGIN + SIZE, w - MARGIN - SIZE * 2);
        ey[i] = rand(MARGIN + SIZE, h - MARGIN - SIZE * 2);

        var side = Math.floor(rand(0, 4));
        if (side === 0) { sx[i] = rand(-SIZE * 2, w + SIZE); sy[i] = -SIZE - rand(20, 140); }
        else if (side === 1) { sx[i] = w + SIZE + rand(20, 140); sy[i] = rand(-SIZE, h + SIZE); }
        else if (side === 2) { sx[i] = rand(-SIZE * 2, w + SIZE); sy[i] = h + SIZE + rand(20, 140); }
        else { sx[i] = -SIZE - rand(20, 140); sy[i] = rand(-SIZE, h + SIZE); }

        px[i] = sx[i];
        py[i] = sy[i];
        vx[i] = 0;
        vy[i] = 0;
        heading[i] = rand(0, Math.PI * 2);
        delay[i] = i * ENTER_STAGGER;
        op[i] = 0;
        released[i] = false;
        floatX[i] = 0;
        floatY[i] = 0;
      }

      function getScrollProgress() {
        var vh = window.innerHeight;
        var scrollY = window.scrollY || window.pageYOffset;
        var startPx = vh * SCROLL_START;
        var endPx = vh * SCROLL_END;
        var raw = (scrollY - startPx) / (endPx - startPx);
        return Math.max(0, Math.min(1, raw));
      }

      function getIconCenter() {
        if (!iconEl) return { x: w / 2, y: h + 200 };
        var iconRect = iconEl.getBoundingClientRect();
        var boxRect = box.getBoundingClientRect();
        return {
          x: (iconRect.left + iconRect.width / 2) - boxRect.left - HALF,
          y: (iconRect.top + iconRect.height / 2) - boxRect.top - HALF
        };
      }

      function place(i) {
        els[i].style.left = px[i] + 'px';
        els[i].style.top = py[i] + 'px';
        els[i].style.opacity = op[i];
      }

      function placeSpiral(i, progress) {
        var eased = easeInOutCubic(progress);
        var center = getIconCenter();

        var finalAngle = i * (2 * Math.PI / n);
        var spiralAngle = finalAngle + (1 - eased) * SPIRAL_TURNS * 2 * Math.PI;

        var spiralX = center.x + Math.cos(spiralAngle) * FINAL_RADIUS;
        var spiralY = center.y + Math.sin(spiralAngle) * FINAL_RADIUS;

        var targetX = lerp(floatX[i], spiralX, eased);
        var targetY = lerp(floatY[i], spiralY, eased);

        var scale = lerp(1, FINAL_SCALE, eased);

        px[i] = targetX;
        py[i] = targetY;
        op[i] = 1;

        els[i].style.left = px[i] + 'px';
        els[i].style.top = py[i] + 'px';
        els[i].style.opacity = 1;
        els[i].style.transform = 'scale(' + scale + ')';
        els[i].style.transformOrigin = '50% 50%';

        if (defaultPaths[i]) {
          if (progress > COLOR_START) {
            var colorT = (progress - COLOR_START) / (1 - COLOR_START);
            colorT = Math.min(1, colorT);
            defaultPaths[i].setAttribute('fill', lerpColor(COLOR_CREAM, COLOR_BLACK, colorT));
          } else {
            defaultPaths[i].setAttribute('fill', 'var(--color-cream-white)');
          }
        }
      }

      function resetParticleColor(i) {
        if (defaultPaths[i]) {
          defaultPaths[i].setAttribute('fill', 'var(--color-cream-white)');
        }
      }

      function releaseParticle(i, t) {
        released[i] = true;
        op[i] = 1;

        var dx = ex[i] - sx[i];
        var dy = ey[i] - sy[i];
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var deriv = easeOutDeriv(t) / ENTER_DURATION;
        var speed = deriv * dist * 16;

        var dirX = dx / dist;
        var dirY = dy / dist;

        speed = Math.min(speed, MAX_SPEED * 0.8);
        speed = Math.max(speed, 0.4);

        vx[i] = dirX * speed;
        vy[i] = dirY * speed;
        heading[i] = Math.atan2(vy[i], vx[i]);
      }

      function computeFloatForces(i) {
        var cx = px[i] + HALF;
        var cy = py[i] + HALF;
        var fx = Math.cos(heading[i]) * WANDER_FORCE;
        var fy = Math.sin(heading[i]) * WANDER_FORCE;

        for (var j = 0; j < n; j++) {
          if (i === j) continue;
          var dx = cx - (px[j] + HALF);
          var dy = cy - (py[j] + HALF);
          var centerDist = Math.sqrt(dx * dx + dy * dy) || 1;
          var edgeGap = centerDist - SIZE;
          if (edgeGap < REPULSE_GAP) {
            var push = (1 - Math.max(0, edgeGap) / REPULSE_GAP) * REPULSE_FORCE;
            fx += (dx / centerDist) * push;
            fy += (dy / centerDist) * push;
          }
        }

        var padL = MARGIN;
        var padR = w - SIZE - MARGIN;
        var padT = MARGIN;
        var padB = h - SIZE - MARGIN;

        if (px[i] < padL) fx += (padL - px[i]) * BOUND_FORCE;
        else if (px[i] > padR) fx -= (px[i] - padR) * BOUND_FORCE;
        if (py[i] < padT) fy += (padT - py[i]) * BOUND_FORCE;
        else if (py[i] > padB) fy -= (py[i] - padB) * BOUND_FORCE;

        return { x: fx, y: fy };
      }

      function tick(now) {
        measure();
        if (!t0) t0 = now;
        var elapsed = now - t0;

        prevScrollProgress = scrollProgress;
        scrollProgress = getScrollProgress();

        var entryDone = true;
        for (var i = 0; i < n; i++) {
          if (!released[i]) { entryDone = false; break; }
        }
        allReleased = entryDone;

        if (scrollProgress > 0) {
          if (wasFlying) {
            wasFlying = false;
            container.classList.remove('cover-rituals--particles-flying');
          }
          if (!floatSnapshotTaken) {
            for (var i = 0; i < n; i++) {
              floatX[i] = px[i];
              floatY[i] = py[i];
              if (!released[i]) {
                op[i] = Math.max(op[i], 0.5);
              }
            }
            floatSnapshotTaken = true;
          }

          for (var i = 0; i < n; i++) {
            placeSpiral(i, scrollProgress);
          }

          if (captionEl) {
            if (scrollProgress >= 1) {
              captionEl.classList.add('cover-rituals__icon-caption--visible');
            } else {
              captionEl.classList.remove('cover-rituals__icon-caption--visible');
            }
          }

          raf = requestAnimationFrame(tick);
          return;
        }

        if (scrollProgress === 0 && prevScrollProgress > 0) {
          for (var i = 0; i < n; i++) {
            floatX[i] = px[i];
            floatY[i] = py[i];
            vx[i] = 0;
            vy[i] = 0;
            els[i].style.transform = '';
            els[i].style.transformOrigin = '';
            op[i] = released[i] ? 1 : op[i];
            resetParticleColor(i);
          }
          floatSnapshotTaken = false;
          if (captionEl) captionEl.classList.remove('cover-rituals__icon-caption--visible');
        }

        for (var i = 0; i < n; i++) {
          if (!released[i]) {
            var t = Math.max(0, (elapsed - delay[i]) / ENTER_DURATION);

            if (t >= HANDOFF_PROGRESS) {
              var e = easeOut(Math.min(1, t));
              px[i] = lerp(sx[i], ex[i], e);
              py[i] = lerp(sy[i], ey[i], e);
              releaseParticle(i, Math.min(1, t));
            } else {
              var e = easeOut(Math.min(1, t));
              px[i] = lerp(sx[i], ex[i], e);
              py[i] = lerp(sy[i], ey[i], e);
              op[i] = Math.min(1, t / 0.3);
              place(i);
              continue;
            }
          }

          if (visible) {
            heading[i] += rand(-TURN_SPEED, TURN_SPEED);

            var f = computeFloatForces(i);
            vx[i] = (vx[i] + f.x) * FRICTION;
            vy[i] = (vy[i] + f.y) * FRICTION;

            var spd = Math.sqrt(vx[i] * vx[i] + vy[i] * vy[i]);
            if (spd > MAX_SPEED) {
              vx[i] = vx[i] / spd * MAX_SPEED;
              vy[i] = vy[i] / spd * MAX_SPEED;
            }

            px[i] += vx[i];
            py[i] += vy[i];

            if (spd > 0.01) {
              heading[i] = Math.atan2(vy[i], vx[i]);
            }
          }

          place(i);
        }

        if (allReleased && scrollProgress === 0) {
          for (var i = 0; i < n; i++) {
            floatX[i] = px[i];
            floatY[i] = py[i];
          }
          floatSnapshotTaken = false;
        }

        var isFlying = allReleased && scrollProgress === 0;
        if (isFlying !== wasFlying) {
          wasFlying = isFlying;
          container.classList.toggle('cover-rituals--particles-flying', isFlying);
        }

        raf = requestAnimationFrame(tick);
      }

      for (var i = 0; i < n; i++) {
        els[i].style.position = 'absolute';
        els[i].style.left = '0';
        els[i].style.top = '0';
      }

      var links = Array.from(container.querySelectorAll('.cover-rituals__particle-link[href]'));
      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          var href = link.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          e.preventDefault();
          history.pushState(null, '', href);
          scrollToHash(href);
        });
      });

      var obs = typeof IntersectionObserver !== 'undefined'
        ? new IntersectionObserver(function(e) { visible = e[0].isIntersecting; }, { threshold: 0 })
        : null;
      if (obs) obs.observe(container);

      raf = requestAnimationFrame(tick);
      window.addEventListener('resize', measure);

      container._coverRitualsDestroy = function() {
        if (raf) cancelAnimationFrame(raf);
        if (obs) obs.disconnect();
        window.removeEventListener('resize', measure);
        container.classList.remove('cover-rituals--particles-flying');
        for (var i = 0; i < n; i++) {
          resetParticleColor(i);
          els[i].style.transform = '';
          els[i].style.transformOrigin = '';
        }
      };
    }

    go();
  }

  function run() {
    document.querySelectorAll('.cover-rituals').forEach(init);
  }

  function handleInitialHash() {
    if (window.location.hash) {
      window.scrollTo(0, 0);
      requestAnimationFrame(function() {
        scrollToHash(window.location.hash);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      run();
      handleInitialHash();
    });
  } else {
    run();
    handleInitialHash();
  }
})();
